import {
  GET_METADATA_INFO,
  SET_PRODUCT_ID,
  SET_VISIBILITY,
} from "../../shared/constants/ActionTypes";

const initalMetaDataInfo = {
  metaDataInfo: [],
};

const metaDataInfoReducer = (state = initalMetaDataInfo, action) => {
  switch (action.type) {
    case GET_METADATA_INFO:
      return {
        ...state,
        metaDataInfo: action.payload.metaData,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };
    case SET_VISIBILITY:
      const updatedMetaDataInfo = {
        ...state.metaDataInfo,
        [action.payload.title]: {
          ...state.metaDataInfo[action.payload.title],
          visibility: !state.metaDataInfo[action.payload.title].visibility,
        },
      };

      return {
        ...state,
        metaDataInfo: updatedMetaDataInfo,
      };
    default:
      return state;
  }
};

export default metaDataInfoReducer;
